import api from '@/services/Api';

export default {
  getConfig() {
    return api(true).get('/app/config');
  },

  getDynamicSubfields(adAccountId) {
    const query = new URLSearchParams({ ad_account_id: adAccountId }).toString();

    return api().get('/app/dynamic-subfields?' + query);
  },
};
